<app-header></app-header>
<app-subheader></app-subheader>

<!-- <app-lobby [ngClass]="{landscape: isMobileLandscape}"></app-lobby> -->
<app-lobby></app-lobby>

<!-- <app-footer *ngIf="!isMobileLandscape"></app-footer> -->
<app-footer></app-footer>

